import * as Styled from './RadioButtonGroup.styled';
import type { RadioButtonField } from './types';

export const RadioButton = ({
  cta,
  description,
  icon,
  isDisabled = false,
  isDiscrete,
  label,
  price,
  value,
}: RadioButtonField) => (
  <Styled.RadioField
    $isDiscrete={isDiscrete}
    isDisabled={isDisabled}
    value={value}
  >
    <Styled.RadioButton id={value} />
    <Styled.Label>
      {label}
      {description ? <span>{description}</span> : null}
    </Styled.Label>
    {cta ? <Styled.Cta>{cta}</Styled.Cta> : null}
    {price ? (
      <Styled.Price $isFree={/free/.test(price)}>{price}</Styled.Price>
    ) : null}
    {icon ? <Styled.Icon>{icon}</Styled.Icon> : null}
  </Styled.RadioField>
);
